import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getStockoutreqList } from 'components/stockoutreq/StockoutreqAPI';
import { getListAPI as getStockoutproductList } from 'components/stockoutproduct/StockoutproductAPI';
import { getListAPI as getStockoutproductToProductOrderList } from 'components/stockoutproducttoproductorder/StockoutproducttoproductorderAPI';
import { setStockoutreqList, setStockoutreqDashboardStockoutreqList,setStockoutproductList,
    setStockoutproducttoproductorderList
 } from 'store/slice/ManufSlice';
import StockoutreqDashboard from '../StockoutreqDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function StockoutreqPageImpl() {
    const dispatch = useDispatch();
    const { stockoutreqList} = useSelector((state)=>state.manufslice);
    
    const getStockoutreqListSuccess = (list) =>{dispatch(setStockoutreqList(list));}
    const getStockoutproductListSuccess = (list) =>{dispatch(setStockoutproductList(list));}
    const getStockoutproductToProductOrderSuccess = (list) =>{dispatch(setStockoutproducttoproductorderList(list));}
    useEffect(() => {
        getStockoutreqList(()=>{}, getStockoutreqListSuccess);
        getStockoutproductList(()=>{}, getStockoutproductListSuccess);
         getStockoutproductToProductOrderList(()=>{}, getStockoutproductToProductOrderSuccess);
        
    },[]);
    useEffect(()=>{
        dispatch(setStockoutreqDashboardStockoutreqList( stockoutreqList));
    },[ stockoutreqList])

    return (
        < StockoutreqDashboard />
    )

}